export default {"src":"/_next/static/media/chatGPTIcon.aff6e31d.svg","height":2406,"width":2406};